Number.prototype.toFixedNew = function (digits = 2) {
  const factor = Math.pow(10, digits);
  return (Math.round((this + Number.EPSILON) * factor) / factor).toFixed(digits);
};
